import { cn } from '@/app/utils'

type Props = {
  rowsWithSizes?: number[]
  rows?: number
  height?: number
  className?: string
  itemClassName?: string
}

export const BadgesSkeleton = ({
  rowsWithSizes,
  height,
  rows,
  className,
  itemClassName
}: Props) => {
  return (
    <ul
      className={cn('flex flex-wrap', className)}
      data-testid="skeleton-badges-id"
    >
      {(rowsWithSizes || Array.from({ length: rows ?? 1 })).map(
        (width, index) => (
          <li
            key={index}
            style={{ width: width ?? 64, height: height ?? 32 }}
            className={cn(
              'mr-8 animate-pulse rounded-12 bg-[rgba(16,24,32,.1)]',
              itemClassName
            )}
          />
        )
      )}
    </ul>
  )
}
